// @ts-check
import { gql, useLazyQuery } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';

/**
 * Used to check if the import is adding new products and if the brand is a producer.
 * @returns
 */
export default function useImportFlow() {
  const { workspaceId, importId } = useParams();

  const [fetchData, { data, loading }] = useLazyQuery(QUERY);
  React.useEffect(() => {
    if (!importId) return;
    fetchData({
      variables: { workspaceId, importId },
    });
  }, [fetchData, importId, workspaceId]);

  return {
    loading: loading || !data,
    ...afterQuery(data),
  };
}

function afterQuery(data) {
  if (!data) return {};

  const importData = data?.workspace?.dataImport;
  const identifierFields = importData?.identifierFields;
  const previewData = importData?.preview?.[0];
  const isAddingNewProducts = previewData?.addedCount > 0;
  const isAllNewProducts =
    previewData?.updatedCount === 0 &&
    previewData?.unchangedCount === 0 &&
    isAddingNewProducts;
  return {
    isAllNewProducts,
    isAddingNewProducts,
    isProducer: data?.workspace?.type === 'winery',
    identifierFields,
    ...previewData,
  };
}

const QUERY = gql`
  query useImportFlow($workspaceId: ID!, $importId: ID!) {
    workspace(workspaceId: $workspaceId) {
      workspaceId
      type
      dataImport(importId: $importId) {
        importId
        importOptions
        preview {
          addedCount
        }
        identifierFields {
          bottlebooksFieldName
          importFieldName
        }
      }
    }
  }
`;
